import type { UrlObject } from 'url';
import { Flex, Icon } from '@chakra-ui/react';
import NextLink from 'next/link';
import { AiOutlineLeft } from 'react-icons/ai';
import { useScreenCheck } from '~/hooks/resources/screen_check';

interface Props {
  href: string | UrlObject;
  enable?: boolean;
}

const defaultProps = {
  enable: true,
};

export const BackFloatButton: React.FC<Props> = (props: Props) => {
  props = { ...defaultProps, ...props };
  if (!props.enable) return null;

  const screeCheck = useScreenCheck(664);

  return (
    <Flex top="64px" position="fixed" w="600px" align="left" zIndex={5}>
      <Flex
        ml={screeCheck.isMobileScreen ? '16px' : '-32px'}
        h="32px"
        w="32px"
        color="white"
        bgColor="disable"
        rounded="full"
        shadow="md"
        justifyContent="center"
        alignItems="center"
        _hover={{ bgColor: 'blank' }}
        _active={{ bgColor: 'blank' }}
      >
        <NextLink href={props.href}>
          <Flex
            w="full"
            h="full"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Icon as={AiOutlineLeft} w="16px" h="16px" />
          </Flex>
        </NextLink>
      </Flex>
    </Flex>
  );
};
